import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

export const GET_CUSTOMER_CATEGORIES = '@customer-categories/get-customer-categories';
export const GET_CUSTOMER_CATEGORIES_SUCCESS = '@customer-categories/get-customer-categories-success';
export const GET_CUSTOMER_CATEGORIES_ERROR = '@customer-categories/get-customer-categories-error';

export const CLEAR_CUSTOMER_CATEGORIES = '@customer-categories/clear-customer-categories';

export const SEND_ADD_CUSTOMER_CATEGORIES = '@customer-categories/send-add-customer-categories';
export const SEND_ADD_CUSTOMER_CATEGORIES_SUCCESS = '@customer-categories/send-add-customer-categories-success';
export const SEND_ADD_CUSTOMER_CATEGORIES_ERROR = '@customer-categories/send-add-customer-categories-error';
export const SET_VALUES_FORM_ADD_CUSTOMER_CATEGORIES = '@customer-categories/set-values-form-add-customer-categories';

export const SEND_REMOVE_CUSTOMER_CATEGORIES = '@customer-categories/send-remove-customer-categories';
export const SEND_REMOVE_CUSTOMER_CATEGORIES_SUCCESS = '@customer-categories/send-remove-customer-categories-success';
export const SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR = '@customer-categories/send-remove-customer-categories-error';

export const SET_CUSTOMER_CATEGORIES_QUERY = '@customer-categories/set-customer-categories-query';
export const SET_SELECTED_CUSTOMER_CATEGORIES = '@customer-categories/set-selected-customer-categories';
export const SET_GO_TO_CATEGORY_DETAILS = '@customer-categories/set-go-to-category-details';
export const CLEAR_GO_TO_CATEGORY_DETAILS = '@customer-categories/clear-go-to-category-details';
export const CLEAR_ALL_CUSTOMER_CATEGORIES_LIST = '@customer-categories/clear-all-customer-categories-list';

export const getCustomerCategories = (isPaginationDisabled = false) => async (dispatch, getState) => {
  dispatch({
    type: GET_CUSTOMER_CATEGORIES,
    payload: isPaginationDisabled,

  });
  try {
    const query = getState()?.customerCategories?.query || {};
    const params = {
      ...query,
      isPaginationDisabled,
      ...(isPaginationDisabled && { page: undefined, pageSize: undefined }),
    };
    const response = await axios.get(`/api/contacts/category/by-contact/${getState().customerDetails?.customer?.id}`, { params });
    dispatch({
      type: GET_CUSTOMER_CATEGORIES_SUCCESS,
      payload: {
        ...response?.data || {},
        isPaginationDisabled,
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CUSTOMER_CATEGORIES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CUSTOMER_CATEGORIES_ERROR,
    });
  }
};

export const sendAddCustomerCategories = (addCustomerCategories, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_ADD_CUSTOMER_CATEGORIES,
    });
    const response = await axios.post('/api/contacts/category', addCustomerCategories);
    const { success } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SEND_ADD_CUSTOMER_CATEGORIES_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_ADD_CUSTOMER_CATEGORIES_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_ADD_CUSTOMER_CATEGORIES_SUCCESS, 'Selected categories have been added.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_ADD_CUSTOMER_CATEGORIES_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(SEND_ADD_CUSTOMER_CATEGORIES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_ADD_CUSTOMER_CATEGORIES_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const sendRemoveContactCategory = (categoryIds = [], doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: SEND_REMOVE_CUSTOMER_CATEGORIES,
  });
  try {
    const response = await axios.delete('/api/contacts/category', {
      data: { ids: categoryIds },
    });
    const payload = response?.data?.success;
    const isMoreThanOne = categoryIds.length > 1;

    if (!payload) {
      dispatch(addNotification(SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR, `Cannot remove ${isMoreThanOne ? 'categories' : 'category'}`, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_REMOVE_CUSTOMER_CATEGORIES_SUCCESS, `${isMoreThanOne ? 'Categories have' : 'Category has'} been successfully removed`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_REMOVE_CUSTOMER_CATEGORIES_SUCCESS,
      payload
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setCustomerCategoriesQuery = (query) => ({
  type: SET_CUSTOMER_CATEGORIES_QUERY,
  payload: query
});

export const setValuesFormAddCustomerCategories = (values) => ({
  type: SET_VALUES_FORM_ADD_CUSTOMER_CATEGORIES,
  payload: values
});

export const setSelectedCustomerCategories = (selectedCustomerCategories) => ({
  type: SET_SELECTED_CUSTOMER_CATEGORIES,
  payload: selectedCustomerCategories
});

export const clearCustomerCategories = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CUSTOMER_CATEGORIES,
  });
};

export const clearAllCustomerCategoriesList = (all = false) => async (dispatch) => {
  dispatch({
    type: CLEAR_ALL_CUSTOMER_CATEGORIES_LIST,
    payload: all,
  });
};

export const setGoToCategoryDetails = (contactId, wasReturned = false, query = false) => async (dispatch) => {
  dispatch({
    type: SET_GO_TO_CATEGORY_DETAILS,
    payload: {
      contactId,
      wasReturned,
      ...query ? { query } : {},
    },
  });
};

export const clearGoToCategoryDetails = (all = false) => async (dispatch) => {
  dispatch({
    type: CLEAR_GO_TO_CATEGORY_DETAILS,
    payload: all,
  });
};
